let excessCalculationCols = [
    {
        key: 'displayLabel',
        display: 'Gadget'
    },
    {
        key: 'currencyCode',
        display: 'Currency'
    },
    {
        key: 'excess',
        display: 'Amount'
    },
    {
        key: 'dateCalculatedAsLocalTime',
        display: 'Date Calculated'
    }
]

export { excessCalculationCols }